import { render } from "./RegistrationReviewInfo.vue?vue&type=template&id=7822c60c&scoped=true&lang=pug"
import script from "./RegistrationReviewInfo.vue?vue&type=script&lang=js"
export * from "./RegistrationReviewInfo.vue?vue&type=script&lang=js"

import "./RegistrationReviewInfo.vue?vue&type=style&index=0&id=7822c60c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7822c60c"]])

export default __exports__